import { feedback, toastTiming } from './tokens.generated.js';
/**
 * Bentuk ikon per arti. Warna TIDAK PERNAH satu-satunya pembawa arti
 * (WCAG 2.2 1.4.1 / ISO 9241-112): setiap status membawa bentuk khas yang
 * bertahan pada render abu-abu, ditambah kata sinyal dan kalimat.
 */
export function feedbackShape(kind) {
    return feedback[kind].shape;
}
/**
 * Umur toast (WCAG 2.2 2.2.1 Timing Adjustable). Galat mengembalikan `null`:
 * ia tidak pernah hilang sendiri, karena pengguna harus sempat membacanya.
 */
export function toastLifetimeMs(kind) {
    switch (kind) {
        case 'success':
            return toastTiming.successMs;
        case 'information':
            return toastTiming.informationMs;
        case 'warning':
            return toastTiming.warningMs;
        case 'danger':
            return toastTiming.errorMs;
    }
}
/**
 * Nada lencana untuk sebuah state workflow. Merah dicadangkan untuk tepat dua
 * hal — catatan berklasifikasi Safety dan tenggat yang sudah terlewat — jadi
 * sebuah state biasa tidak pernah memetakan ke `danger`.
 */
export function badgeToneFor(badgeTone) {
    switch ((badgeTone ?? '').toUpperCase()) {
        case 'SUCCESS':
            return 'success';
        case 'WARNING':
            return 'warning';
        case 'DANGER':
            return 'danger';
        case 'INFORMATION':
            return 'information';
        default:
            return 'neutral';
    }
}
//# sourceMappingURL=semantics.js.map